import { AppBar, Box, Toolbar, Typography, Stack } from "@mui/material";
import React from "react";
import { explanationFieldData } from "../database/formData";
import logo from "../images/logo.png";

function TopBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: "#F2F2F3" }}>
        <Toolbar
          variant="dense"
          sx={{
            backgroundColor: "#4C1B72",
            borderBottomRightRadius: 25,
            borderBottomLeftRadius: 25,
          }}
        >
          <Stack>
            <Box
              component="img"
              sx={{
                height: 110,
                width: 110,
                direction: "rtl",
                backgroundColor: "#FFFFFF",
                borderBottomLeftRadius: 25,
                borderBottomRightRadius: 25,
                color: "white",
                paddingX: "8%",
                alignSelf: "center",
              }}
              alt="logo"
              src={logo}
            />
            <Typography
              variant="h6"
              align="center"
              sx={{
                direction: "rtl",
                paddingY: "2%",
                paddingRight: "3%",
                color: "#FFFFFF",
                fontSize: 15,
              }}
            >
              <span style={{ fontWeight: "400" }}>
                {" "}
                {explanationFieldData.banner1}
              </span>
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {explanationFieldData.banner2}
              </span>
              <span> {explanationFieldData.banner3}</span>
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {explanationFieldData.banner4}
              </span>
              <span> {explanationFieldData.banner5}</span>
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default TopBar;
